
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M27 6H9a3 3 0 00-3 3v1.5h24V9a3 3 0 00-3-3zm4.5 4.5V27a4.5 4.5 0 01-4.5 4.5H9A4.5 4.5 0 014.5 27V9A4.5 4.5 0 019 4.5h18A4.5 4.5 0 0131.5 9v1.5zM6 12v15a3 3 0 003 3h18a3 3 0 003-3V12H6zm4.5 3.75a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zm6.75-.75a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm-6 4.5a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3zm6 0a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm-6 4.5a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3zm6 0a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5z","clip-rule":"evenodd"}})])
          )
        }
      }
    